const $ = window.$;

const success = function (data) {
  console.log(data);
};

const error = function (response) {
  console.log(response);
};

function post(url, data, successCallback = success, errorCallback = error) {
  send('post', url, data, successCallback, errorCallback);
}

function get(url, data, successCallback = success, errorCallback = error) {
  send('get', url, data, successCallback, errorCallback);
}

function send(method, url, data, successCallback, errorCallback) {
  $.ajax({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    url: url,
    type: method,
    data: data,
    dataType: 'html',
    success: function (data) {
      successCallback(data);
    },
    error: function (response) {
      errorCallback(response);
    }
  });
}

export { post, get };
